import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";

interface Props {
  modelValue?: boolean;
  /** Khi có value → dùng như option trong checkbox group */
  value?: string | number | boolean;
  label?: string;
  disabled?: boolean;
  indeterminate?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    modelValue: { type: Boolean, default: false },
    value: { type: [String, Number, Boolean], default: undefined },
    label: { default: "" },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isGroupItem = computed(() => props.value !== undefined);

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (e: { target: { checked: boolean } }) => {
  emit("update:modelValue", e.target.checked);
  emit("change", e.target.checked);
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (isGroupItem.value)
    ? (_openBlock(), _createBlock(_component_a_checkbox, {
        key: 0,
        value: _ctx.value,
        disabled: _ctx.disabled,
        indeterminate: _ctx.indeterminate
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]),
        _: 3
      }, 8, ["value", "disabled", "indeterminate"]))
    : (_openBlock(), _createBlock(_component_a_checkbox, {
        key: 1,
        checked: innerValue.value,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
        disabled: _ctx.disabled,
        indeterminate: _ctx.indeterminate,
        onChange: onChange
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]),
        _: 3
      }, 8, ["checked", "disabled", "indeterminate"]))
}
}

})